import React, { Component } from 'react';
import { inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { ManualSignalForm } from './ManualSignalForm';

@withRouter
@inject('store')
export class TethosSignalView extends Component {
    render() {
        const { config } = this.props.store.odysseyBotStore;

        return (
            <ManualSignalForm
                location="tethos"
                data={(config.signal_providers && config.signal_providers.tethos) || {}}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/OdysseyBot/SignalsView/TethosSignalView.js